/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InvitationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Send invitation email to a new customer
     * @returns any Invitation sent successfully or customer linked
     * @throws ApiError
     */
    public postInvitations({
        requestBody,
    }: {
        requestBody?: {
            email: string;
            name?: string;
        },
    }): CancelablePromise<{
        message: string;
        signupUrl: string;
        email: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/invitations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Customer already linked`,
                403: `Only trainers can send invitations`,
            },
        });
    }

    /**
     * Get pending invitations sent by the current trainer
     * @returns any List of sent pending invitations
     * @throws ApiError
     */
    public getInvitationsSent(): CancelablePromise<{
        invitations: Array<{
            id: string;
            customerId: string;
            customerName: string | null;
            customerEmail: string;
            signupUrl: string;
            createdAt: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/invitations/sent',
        });
    }

    /**
     * Get pending trainer invitations for the current customer
     * @returns any List of pending invitations
     * @throws ApiError
     */
    public getInvitationsPending(): CancelablePromise<{
        invitations: Array<{
            id: string;
            trainerId: string;
            trainerName: string | null;
            trainerEmail: string;
            createdAt: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/invitations/pending',
        });
    }

    /**
     * Accept a pending trainer invitation
     * @returns any Invitation accepted successfully
     * @throws ApiError
     */
    public postInvitationsAccept({
        invitationId,
    }: {
        invitationId: string,
    }): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/invitations/accept/{invitationId}',
            path: {
                'invitationId': invitationId,
            },
            errors: {
                404: `Invitation not found`,
            },
        });
    }

    /**
     * Reject a pending trainer invitation
     * @returns any Invitation rejected successfully
     * @throws ApiError
     */
    public postInvitationsReject({
        invitationId,
    }: {
        invitationId: string,
    }): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/invitations/reject/{invitationId}',
            path: {
                'invitationId': invitationId,
            },
            errors: {
                404: `Invitation not found`,
            },
        });
    }

    /**
     * Decode invitation code and get customer access token
     * @returns any Invitation decoded successfully
     * @throws ApiError
     */
    public getInvitations({
        code,
    }: {
        code: string,
    }): CancelablePromise<{
        email: string;
        trainerId: string;
        customerAccessToken: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/invitations/{code}',
            path: {
                'code': code,
            },
            errors: {
                400: `Invalid invitation code`,
            },
        });
    }

}
